// Ký ảnh/ký nháy được vẽ lên PDF rồi ghi lại cả file nên làm mất hiệu lực chữ ký số đã có trên file đó.
// Cùng quy tắc với API (SignPageController, POST add-location-sign).
const SIGN_TYPE_IMAGE = 1;
const SIGN_TYPE_DIGITAL = 2;
const SIGN_TYPE_INITIALS = 3;

export interface StepSignFiles {
  name: string;
  typesigncustomer: number;
  files: string[];
}

export interface SignOrderConflict {
  stepName: string;
  fileName: string;
}

// Các bước theo đúng thứ tự ký
export function findImageAfterDigitalStep(
  steps: StepSignFiles[]
): SignOrderConflict | null {
  const digitalSignedFiles = new Set<string>();
  for (const step of steps) {
    if (
      step.typesigncustomer === SIGN_TYPE_IMAGE ||
      step.typesigncustomer === SIGN_TYPE_INITIALS
    ) {
      const file = step.files.find((f) => digitalSignedFiles.has(f));
      if (file)
        return { stepName: step.name, fileName: file.split("/").pop() ?? file };
    }
    if (step.typesigncustomer === SIGN_TYPE_DIGITAL)
      step.files.forEach((f) => digitalSignedFiles.add(f));
  }
  return null;
}

export function signOrderConflictMessage(conflict: SignOrderConflict): string {
  return `Bước "${conflict.stepName}" ký ảnh/ký nháy trên file ${conflict.fileName} sau một bước ký số. Ký ảnh sau ký số sẽ làm mất hiệu lực chữ ký số: hãy đặt bước ký ảnh trước bước ký số, hoặc đổi bước này thành ký số.`;
}
